import { useEnsAddress, useEnsAvatar, useEnsName } from "wagmi";
import { mainnet } from "wagmi/chains";
import {
  getVerifiedEnsDisplay,
  isValidEthereumAddress,
  normalizeAddress,
  normalizeEnsName,
} from "../utils/walletDisplay";

export default function useVerifiedEnsName(address) {
  const normalizedAddress = normalizeAddress(address);
  const addressEnabled = isValidEthereumAddress(normalizedAddress);

  const {
    data: reverseName,
    isLoading: isReverseLoading,
    isError: isReverseError,
  } = useEnsName({
    address: normalizedAddress,
    chainId: mainnet.id,
    query: {
      enabled: addressEnabled,
      staleTime: 1000 * 60 * 10,
    },
  });

  const normalizedReverseName = normalizeEnsName(reverseName);

  const {
    data: forwardAddress,
    isLoading: isForwardLoading,
    isError: isForwardError,
  } = useEnsAddress({
    name: normalizedReverseName || undefined,
    chainId: mainnet.id,
    query: {
      enabled: Boolean(addressEnabled && normalizedReverseName),
      staleTime: 1000 * 60 * 10,
    },
  });

  const verifiedDisplay = getVerifiedEnsDisplay({
    address: normalizedAddress,
    reverseName: normalizedReverseName,
    forwardAddress,
  });

  const { data: avatarUrl } = useEnsAvatar({
    name: verifiedDisplay.ensName || undefined,
    chainId: mainnet.id,
    query: {
      enabled: Boolean(verifiedDisplay.ensName),
      staleTime: 1000 * 60 * 10,
    },
  });

  return {
    ...verifiedDisplay,
    address: normalizedAddress,
    avatarUrl: avatarUrl || null,
    isLoading: Boolean(
      addressEnabled &&
        (isReverseLoading || (normalizedReverseName && isForwardLoading))
    ),
    isError: Boolean(
      isReverseError || isForwardError || (reverseName && !normalizedReverseName)
    ),
  };
}
